<template>
  <CustomDialogWrapper dialogHeight="220px" @closeDialog="closeDialog">
    <template #title>
      <p :class="$style.title">请输入新签名</p>
    </template>
    <template #main-content>
      <van-field
        v-model="userMotto"
        :class="$style.content"
        placeholder="写下您征服世界的座右铭(最多16个字)~"
        maxlength="16"
        clearable
      />
    </template>
    <template #footer>
      <van-button :class="$style.submit" type="info" @click="submit">修改</van-button>
    </template>
  </CustomDialogWrapper>
</template>

<script>
import CustomDialogWrapper from '_c/CustomDialogs/CustomDialogWrapper';
import { Field, Button, Dialog, Toast } from 'vant';
import { setMotto } from '@/api/account';
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  props: {
    userInfoMotto: { type: String, default: '' }
  },
  components: {
    CustomDialogWrapper,
    VanField: Field,
    VanButton: Button
  },
  data() {
    return {
      userMotto: this.userInfoMotto,
      brushFlag: false
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: state => state.userInfo
    }),
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING'
    }),
    ...mapActions('account', {
      getUserInfo: 'getUserInfo'
    }),
    submit() {
      if (this.userMotto == this.userInfo.forum_user.motto) {
        Toast("新签名与原签名相同，不需要修改！");
        return
      }
      if (!this.userMotto) {
        Toast("签名不能为空！");
        return
      }
      if (this.brushFlag) return
      this.brushFlag = true
      Dialog.alert({
        title: '修改签名',
        message: `原签名“${this.userInfo.forum_user.motto}”  \n新签名“${this.userMotto}”`,
        showCancelButton: true
      }).then(async () => {
        this.CHANGE_SHOW_LOADING(true)
        const r = await setMotto({
          motto: this.userMotto,
        })
        this.CHANGE_SHOW_LOADING(false)
        Toast.success('修改成功');
        this.getUserInfo();
        this.$emit('closeDialog');
        this.brushFlag = false
      }).catch(error => {
        this.userMotto = this.userInfo.forum_user.motto
        this.CHANGE_SHOW_LOADING(false)
        Toast.fail(error.message);
        this.brushFlag = false
      });
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.title {
  margin-bottom: 20px;
  color: #292929;
}
.content {
  @include border-bottom-1px;
}
.submit {
  width: 247px;
  border-radius: 22px;
  background: linear-gradient(-90deg, rgba(36, 180, 254, 1), rgba(82, 208, 255, 1));
  border: none;
}
</style>